/* El back manda la variación ya calculada como porcentaje (ej. 12 => 12%, -18 => -18%).
   Este componente solo pinta el signo: no vuelve a calcular nada. */
const ChipVariacion = ({ variacion, etiqueta }) => {
    if (variacion === null || variacion === undefined) {
        return (
            <div className="d-flex align-items-center gap-2 mt-2" style={{ fontSize: 13 }}>
                <span className="badge" style={{ backgroundColor: '#e3e1fb', color: '#4f46d9', fontWeight: 700 }}>
                    Nuevo
                </span>
                {etiqueta && <span className="text-muted">{etiqueta}</span>}
            </div>
        );
    }

    const v = Number(variacion) || 0;
    const sube = v > 0;
    const baja = v < 0;

    const estilo = sube
        ? { backgroundColor: '#d1e7dd', color: '#198754' }
        : baja
            ? { backgroundColor: '#f8d7e0', color: '#c0144d' }
            : { backgroundColor: '#e9ecef', color: '#6c757d' };

    return (
        <div className="d-flex align-items-center gap-2 mt-2" style={{ fontSize: 13 }}>
            <span className="badge" style={{ ...estilo, fontWeight: 700 }}>
                {sube ? '▲' : baja ? '▼' : ''} {Math.round(Math.abs(v))}%
            </span>
            {etiqueta && <span className="text-muted">{etiqueta}</span>}
        </div>
    );
};

export default ChipVariacion;
